import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Button } from '@/components/ui/Button';
import { SubjectForm } from '@/components/subjects/SubjectForm';
import { subjectsService, CreateSubjectData } from '@/services/subjects.service';

const CreateSubject: React.FC = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (data: CreateSubjectData, photoFile?: File) => {
    setSubmitting(true);
    try {
      const subject = await subjectsService.createSubject(data);
      if (photoFile) {
        try {
          await subjectsService.uploadSubjectPhoto(subject.id, photoFile);
        } catch {
          // Subject was created; photo upload failure shouldn't block navigation.
        }
      }
      navigate(`/security/subjects/${subject.id}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="p-4 sm:p-6 space-y-6">
      <div className="flex items-center gap-3">
        <Button variant="outline" size="sm" onClick={() => navigate('/security/subjects')}>
          <ArrowLeftIcon className="w-4 h-4 mr-1" />
          Back
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-secondary-900 dark:text-white">New Subject</h1>
          <p className="text-secondary-600 dark:text-secondary-400">
            Add a person to the subject registry
          </p>
        </div>
      </div>

      <SubjectForm
        onSubmit={handleSubmit}
        onCancel={() => navigate('/security/subjects')}
        submitting={submitting}
        submitLabel="Create Subject"
      />
    </div>
  );
};

export default CreateSubject;
